import { LoginArea } from '@/components/auth/LoginArea';

const TRUTHS = [
  'you are a key.',
  'your words are signed.',
  'relays carry them.',
  'no one can silence them.',
  'you are not alone.',
];

const TRUTHS_END = 400 + TRUTHS.length * 850;

/** Outro — the five truths, then an open door to the real network. */
export function Farewell({ onRestart }: { onRestart: () => void }) {
  return (
    <div className="relative z-10 flex min-h-dvh flex-col items-center justify-center gap-10 px-6 py-24 text-center">
      <div className="space-y-3">
        {TRUTHS.map((t, i) => (
          <p
            key={t}
            className="animate-zen-fade-up font-serif text-2xl italic text-slate-200/85 sm:text-3xl"
            style={{ animationDelay: `${400 + i * 850}ms` }}
          >
            {t}
          </p>
        ))}
      </div>

      <h2
        className="animate-zen-fade-up zen-text-glow pt-6 font-serif text-5xl text-amber-100 sm:text-6xl"
        style={{ animationDelay: `${TRUTHS_END + 400}ms` }}
      >
        welcome to nostr.
      </h2>

      <div
        className="animate-zen-fade-up flex flex-col items-center gap-6 pt-4"
        style={{ animationDelay: `${TRUTHS_END + 1000}ms` }}
      >
        <p className="font-sans text-[11px] uppercase tracking-[0.4em] text-white/40">
          when you're ready —
        </p>
        <LoginArea className="max-w-60" />
        <button
          type="button"
          onClick={onRestart}
          className="font-sans text-[11px] uppercase tracking-[0.4em] text-white/35 transition-colors duration-500 hover:text-amber-100/80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber-100/60"
        >
          walk again
        </button>
      </div>
    </div>
  );
}
